import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import useImageCompatibilityWarningModal from "../hooks/use-image-compatibility-warning";
import { useMode } from "../hooks/use-mode";

// Image compatibility warning dialog component
export const ImageCompatibilityWarningModal = () => {
  const { isOpen, onClose, studySetId } = useImageCompatibilityWarningModal();
  const {
    mode: { label },
  } = useMode();
  const router = useRouter();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Notice: Image Cards Compatibility</DialogTitle>
          <DialogDescription>
            Cards with images on the answer side only work in flashcard mode. If
            you continue with <span className="lowercase">{label}</span> mode,
            these specific cards won&apos;t be included, though all other cards
            will function normally.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-col gap-2 mt-4 sm:space-x-0">
          <Button
            type="button"
            className="w-full"
            onClick={() => {
              router.replace(`/studysets/${studySetId}/quiz?mode=flashcards`);
              onClose();
            }}
          >
            Switch to Flashcards Mode
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={onClose}
          >
            Continue with {label} Mode
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
